<template>
  <div id="data-list-list-view" class="data-list-container">
    <data-view-sidebar :isSidebarActive="addNewDataSidebar" @closeSidebar="toggleDataSidebar" :data="sidebarData" />
    <vs-table ref="table" pagination :max-items="itemsPerPage" search :data="items">
      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
        <vs-button type="border" icon-pack="feather" icon="icon-plus" v-if="canAddItem" @click="addNewData">
          {{ $t("AddNew") }}
        </vs-button>
      </div>
      <template slot="thead">
        <vs-th sort-key="NameAr">{{ $t("PropertyType") }}</vs-th>
        <vs-th sort-key="Code">{{ $t("Code") }}</vs-th>
        <vs-th sort-key="IsActive">{{ $t("Status") }}</vs-th>
        <vs-th v-if="canManageItem">{{ $t("Actions") }}</vs-th>
      </template>
      <template slot-scope="{ data }">
        <tbody>
          <tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" @click="editData(tr)">
            <vs-td><p class="product-name font-medium truncate">{{ currentLang === "ar" ? (tr.NameAr || "-") : (tr.NameEn || "-") }}</p></vs-td>
            <vs-td><p class="product-name font-medium truncate">{{ tr.Code || "-" }}</p></vs-td>
            <vs-td><vs-chip :color="tr.IsActive ? 'success' : 'danger'">{{ tr.IsActive ? $t("Active") : $t("Inactive") }}</vs-chip></vs-td>
            <vs-td v-if="canManageItem" class="whitespace-no-wrap" @click.stop>
              <div class="icon-container">
                <feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary cursor-pointer" class="mr-3" @click.stop="editData(tr)" />
                <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger cursor-pointer" @click.stop="openConfirm(tr)" />
              </div>
            </vs-td>
          </tr>
        </tbody>
      </template>
    </vs-table>
  </div>
</template>

<script>
import moduleRef from "@/store/settings/PropertyType/modulePropertyType.js";
import DataViewSidebar from "./DataViewSidebar.vue";
import { canAdd, canEdit, canDelete } from "@/utils/permissions";

export default {
  components: { DataViewSidebar },
  data() {
    return { itemsPerPage: 10, isMounted: false, addNewDataSidebar: false, sidebarData: {}, rowDataForDelete: null };
  },
  computed: {
    currentLang() { return localStorage.getItem("SaveLang") || "en"; },
    items() { return this.$store.state.propertyTypeList.items || []; },
    canAddItem() { return canAdd(); },
    canManageItem() { return canEdit() || canDelete(); }
  },
  methods: {
    addNewData() { this.sidebarData = {}; this.toggleDataSidebar(true); },
    editData(data) { if (!this.canManageItem) return; this.sidebarData = data; this.toggleDataSidebar(true); },
    toggleDataSidebar(val = false) { this.addNewDataSidebar = val; },
    openConfirm(data) {
      this.rowDataForDelete = data;
      this.$vs.dialog({ type: "confirm", color: "danger", title: this.$t("Confirm"), text: this.$t("DeleteConfirmText"), accept: this.acceptAlert, acceptText: this.$t("Delete"), cancelText: this.$t("Cancel") });
    },
    acceptAlert() { this.deleteData(this.rowDataForDelete); },
    deleteData(data) {
      this.$store.dispatch("propertyTypeList/removeItem", data).then(() => {
        this.$store.dispatch("propertyTypeList/fetchDataListItems");
        this.$vs.notify({ time: 5000, color: "success", title: this.$t("Success"), text: this.$t("DeletedSuccessfully") });
      }).catch((err) => {
        let errorMessage = this.$t("Error");
        if (err && err.response && err.response.data && err.response.data.Message) errorMessage = err.response.data.Message;
        this.$vs.dialog({ type: "alert", color: "danger", title: this.$t("Error"), text: errorMessage, acceptText: "OK" });
        this.$store.dispatch("propertyTypeList/fetchDataListItems");
      });
    }
  },
  created() {
    if (!moduleRef.isRegistered) { this.$store.registerModule("propertyTypeList", moduleRef); moduleRef.isRegistered = true; }
    this.$store.dispatch("propertyTypeList/fetchDataListItems");
  },
  beforeDestroy() {
    if (this.$store && this.$store.state.propertyTypeList) { this.$store.unregisterModule("propertyTypeList"); moduleRef.isRegistered = false; }
  }
};
</script>
